import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateCustomerFormComponent } from './create-customer-form/create-customer-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ContractBillingUIService } from './contract-billing-ui.service';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDatepickerModule,
    MatMomentDateModule
  ],
  providers: [ContractBillingUIService],
  declarations: [CreateCustomerFormComponent],
  exports: [CreateCustomerFormComponent],
  entryComponents: []
})
export class ContractBillingUIModule { }
